const DEFAULT_RESULT = "this drug";
export function extractDrugClassFromFilename(filename) {
  if (!filename || typeof filename !== "string") {
    return DEFAULT_RESULT;
  }

  try {
    const match = filename.match(/using-(.+?)_topic/);
    if (match && match[1]) {
      return match[1].replace(/-/g, " ");
    }

    return DEFAULT_RESULT;
  } catch (error) {
    console.error("Error extracting drug class:", error);
    return DEFAULT_RESULT;
  }
}
